import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { NavLink, Redirect, Prompt } from "react-router-dom";
import Can from "../../components/can";
import s from "./index.module.css";
import {
  updateMyProfile,
  updateMyProfileExt,
} from "../../redux/person/actions";
import MuiPhoneNumber from "material-ui-phone-number";
import * as classnames from "classnames";
import { updateMyOrganization } from "../../redux/organization/actions";
import { checkPermission } from "../../rbac";
import { Box } from "@material-ui/core";
import { alertAdd, recoverPassword } from "../../redux/actions";
import ShippingAddressForm from "../../components/address-form/shipping-info";
import makeStyles from "@material-ui/core/styles/makeStyles";
import withStyles from "@material-ui/core/styles/withStyles";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";
import TextField from "@material-ui/core/TextField";
import InputLabel from "@material-ui/core/InputLabel";
import Button from "@material-ui/core/Button";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import PageTitle from "../../components/page-title";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import DateFnsUtils from "@date-io/date-fns";
import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider,
} from "@material-ui/pickers";
import plLocale from "date-fns/locale/pl";
import Tooltip from "@material-ui/core/Tooltip";
import EventIcon from "@material-ui/icons/Event";
import { getLoginRedirectPath } from "../../redux/common";

const ContrastCheckbox = withStyles((theme) => ({
  root: {
    color:
      theme.palette.primary.main === "#fff200" && theme.palette.primary.main,
    "&$checked": {
      color:
        theme.palette.primary.main === "#fff200" && theme.palette.primary.main,
    },
    "&.Mui-disabled": {
      color: theme.palette.primary.main === "#fff200" && "#c2b90c",
    },
  },
}))(Checkbox);

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.default,
  },
  fontSize: {
    "& .MuiAlert-icon": {
      fontSize: theme.typography.body1.iconSize,
    },
    fontSize: theme.typography.body1.fontSize,
  },
  aalertHighContrast: {
    color: theme.palette.text.primary,
    fontWeight: "bold",
    fontFamily: "helvetica",
    textDecoration: "underline",
    "&:hover": {
      color: theme.palette.text.primary,
    },
  },
  paper: {
    padding: theme.spacing(2),
    textAlign: "left",
    color: theme.palette.text.primary,
    border:
      theme.palette.primary.main === "#fff200" &&
      `1px solid ${theme.palette.text.primary}`,
  },
  root: {
    "& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
      borderColor:
        theme.palette.primary.main === "#fff200" && theme.palette.primary.main,
    },
    "&:hover .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
      borderColor:
        theme.palette.primary.main === "#fff200" && theme.palette.primary.main,
    },
    "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor:
        theme.palette.primary.main === "#fff200" && theme.palette.primary.main,
    },
    "& .MuiOutlinedInput-input": {
      color:
        theme.palette.primary.main === "#fff200" && theme.palette.primary.main,
    },
    "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-input": {
      color:
        theme.palette.primary.main === "#fff200" && theme.palette.primary.main,
    },
    "& .MuiInputLabel-outlined": {
      color: theme.palette.primary.main === "#fff200" && "#c2b90c",
    },
    "& .MuiInputLabel-outlined.Mui-focused": {
      color:
        theme.palette.primary.main === "#fff200" && theme.palette.primary.main,
    },
  },
}));

const genderTypes = [
  {
    type: "Female",
    description: "Kobieta",
  },
  {
    type: "Male",
    description: "Mężczyzna",
  },
];

let actualDate = new Date();
actualDate.setUTCHours(0);

const ProfilePage = ({ history }) => {
  const my = useSelector((s) => s.my);
  const globalTheme = useSelector((s) => s.globalTheme);
  const enableProfileDataEdition = useSelector(
    (s) => s.my.enableProfileDataEdition
  );
  const organization = useSelector((s) => s.organization);
  const roles = useSelector((s) => s.roles);
  const enableEmailEdition =
    roles && roles.length === 1 && roles[0] === "ROLE_USER";

  const classes = useStyles();

  const [firstName, setFirstName] = useState((my && my.firstName) || "");
  const [lastName, setLastName] = useState((my && my.surname) || "");
  const [selectedGender, setSelectedGender] = useState((my && my.gender) || "");

  const [yearOfBirth, setYearOfBirth] = useState(
    (my && my.yearOfBirth?.toString()) || null
  );

  const [username, setUsername] = useState(
    (my && my.user && my.user.username) || ""
  );
  const [email, setEmail] = useState((my && my.user && my.user.email) || "");
  const avatarPath = (my && my.avatarPath) || "";
  const [newAvatarPath, setNewAvatarPath] = useState(null);
  const [avatarImage, setAvatarImage] = useState();

  const [name, setName] = useState("");
  const [street, setStreet] = useState("");
  const [zip, setZip] = useState("");
  const [city, setCity] = useState("");
  const [post, setPost] = useState("");
  const [phone, setPhone] = useState(null);

  const [nameFV, setNameFV] = useState("");
  const [streetFV, setStreetFV] = useState("");
  const [zipFV, setZipFV] = useState("");
  const [cityFV, setCityFV] = useState("");
  const [nipFV, setNipFV] = useState("");
  const [postFV, setPostFV] = useState("");

  const [orgName, setOrgName] = useState("");
  const [additionalOrgDescription, setAdditionalOrgDescription] = useState("");
  const [customFooter, setCustomFooter] = useState("");
  const [orgMessage, setOrgMessage] = useState("");
  const [orgCode, setOrgCode] = useState("");
  const [formDataCreatedWebhookUrl, setFormDataCreatedWebhookUrl] = useState(
    ""
  );
  const [selfRegistration, setSelfRegistration] = useState(false);
  const [userActivation, setUserActivation] = useState(false);
  const [orgCodeRequired, setOrgCodeRequired] = useState(false);
  const [busy, setBusy] = useState(false);
  const [displayHint, setDisplayHint] = useState(false);

  const [dialCode, setDialCode] = useState("48");

  const [emergencyFirstName, setEmergencyFirstName] = useState("");
  const [emergencySurname, setEmergencySurname] = useState("");
  const [emergencyPhone, setEmergencyPhone] = useState("");
  const [emergencyEmail, setEmergencyEmail] = useState("");
  const [emergencyAddress, setEmergencyAddress] = useState("");

  const [dataProvidedValid, setDataProvidedValid] = useState(false);
  const [yearProvidedValid, setYearProvidedValid] = useState(false);
  const [editorsCanManageForms, setEditorsCanManageForms] = useState(false);
  const [editorsCanManageUsers, setEditorsCanManageUsers] = useState(false);
  const dispatch = useDispatch();

  const [dataChanged, setDataChanged] = useState(false);
  //const enableProfileDataEdition = my.enableProfileDataEdition || true;

  const handleUploadedFiles = (files) => {
    if (files.length > 0) {
      const file = files[0];

      let reader = new FileReader();
      reader.onloadend = () => {
        setAvatarImage(file);
        setNewAvatarPath(reader.result);
      };

      reader.readAsDataURL(file);
    }
  };

  useEffect(() => {
    if (my?.phone) {
      setPhone(my.phone);
    }
    if (organization) {
      setOrgName(organization.orgName || "");
      setAdditionalOrgDescription(organization.additionalOrgDescription || "");
      setCustomFooter(organization.customFooter || "");

      setOrgMessage(organization.orgMessage || "");
      setOrgCode(organization.orgCodeRegistration || "");
      setFormDataCreatedWebhookUrl(
        organization.formDataCreatedWebhookUrl || ""
      );
      setOrgCodeRequired(organization.enableCodeRegistration || false);
      setUserActivation(organization.enableUserActivation || false);
      setSelfRegistration(organization.enableSelfRegistration || false);
      setEditorsCanManageForms(organization.editorsCanManageForms || false);
      setEditorsCanManageUsers(organization.editorsCanManageUsers || false);

      if (organization.billingInfo) {
        setNameFV(organization.billingInfo.name || "");
        setStreetFV(organization.billingInfo.street || "");
        setZipFV(organization.billingInfo.zipCode || "");
        setCityFV(organization.billingInfo.city || "");
        setNipFV(organization.billingInfo.taxId || "");
        setPostFV(organization.billingInfo.post || "");
      }
    }
  }, [organization, my]);

  useEffect(() => {
    setDataProvidedValid(
      !zip || zip.length === 6
      // &&
      //   (!phone || phone.length === 12 || phone.length < dialCode.length + 2)
    );
  }, [phone, zip]);

  useEffect(() => {
    if (yearOfBirth) {
      setYearProvidedValid(
        yearOfBirth?.length === 4 &&
          yearOfBirth > 1899 &&
          yearOfBirth <= new Date().getFullYear()
      );
    } else {
      setYearProvidedValid(true);
    }
  }, [yearOfBirth]);

  useEffect(() => {
    if (my) {
      if (my.address) {
        setName(my.address.name || "");
        setStreet(my.address.street || "");
        setZip(my.address.zipCode || "");
        setCity(my.address.city || "");
        setPost(my.address.post || "");
        setPhone(my.phone || null);
      }
      const ec = my.emergencyContact;
      setEmergencyFirstName(ec?.firstName || "");
      setEmergencySurname(ec?.surname || "");
      setEmergencyPhone(ec?.phone || "");
      setEmergencyEmail(ec?.email || "");
      setEmergencyAddress(ec?.address || "");
    }
  }, [my]);

  const save = async () => {
    setBusy(true);
    const canUpdateOrgData = checkPermission("orgDetails:change", roles);

    const loginToChange =
      (my.user.email && my.user.email?.toLowerCase() !== email) ||
      (my.user.phone &&
        my.user.phone !== phone &&
        roles &&
        roles.length === 1 &&
        roles[0] === "ROLE_USER");
    const avatarPath = newAvatarPath;

    let response = {};

    const normalizedEmergencyPhone = emergencyPhone
      ? emergencyPhone.replace(/[^+\d]+/g, "")
      : null;
    const emergencyContactPayload = {
      emergencyContact: {
        firstName: emergencyFirstName || null,
        surname: emergencySurname || null,
        phone:
          normalizedEmergencyPhone && normalizedEmergencyPhone !== "+"
            ? normalizedEmergencyPhone
            : null,
        email: emergencyEmail || null,
        address: emergencyAddress || null,
      },
    };

    if (avatarImage) {
      response = await dispatch(
        updateMyProfileExt({
          firstName,
          surname: lastName,
          ...(yearOfBirth ? { yearOfBirth: parseInt(yearOfBirth, 10) } : {}),
          ...(selectedGender ? { gender: selectedGender } : {}),
          ...(phone && phone !== "+48"
            ? { phone: phone?.replace(/[^+\d]+/g, "") }
            : {}),
          street,
          mail: email,
          city,
          post,
          zip,
          avatarImage,
          address: {
            name,
            street,
            zipCode: zip,
            city,
            post,
            ...(phone ? { phone } : {}),
          },
          ...emergencyContactPayload,
        })
      );
    } else {
      response = await dispatch(
        updateMyProfile({
          firstName,
          surname: lastName,
          ...(yearOfBirth ? { yearOfBirth: parseInt(yearOfBirth, 10) } : {}),
          ...(selectedGender ? { gender: selectedGender } : {}),
          ...(phone ? { phone: phone?.replace(/[^+\d]+/g, "") } : {}),
          street,
          mail: email,
          city,
          post,
          zip,
          avatarImage,
          address: {
            name,
            street,
            zipCode: zip,
            city,
            post,
            ...(phone ? { phone } : {}),
          },
          ...emergencyContactPayload,
        })
      );
    }

    if (response.status === 200) {
      setBusy(false);

      if (loginToChange) {
        dispatch(
          alertAdd({
            text:
              "Zaktualizowano profil. Z uwagi na zmianę loginu wymagane jest ponowne zalogowanie.",
            isWarning: true,
            timeout: 4000,
          })
        );

        setTimeout(() => {
          window.location.reload();
        }, 4000);
      } else {
        setDataChanged(false);
        dispatch(alertAdd({ text: "Zaktualizowano profil", isSuccess: true }));

        setNewAvatarPath(null);
      }
    } else if (response.data.message.includes("Phone is not unique")) {
      setBusy(false);
      dispatch(
        alertAdd({
          text:
            "Nie udało się dokonać edycji. Podany numer telefonu istnieje już w systemie.",
          isError: true,
        })
      );
    } else if (response.data.message.includes("Email is not unique")) {
      setBusy(false);
      dispatch(
        alertAdd({
          text:
            "Nie udało się dokonać edycji. Podany adres email istnieje już w systemie.",
          isError: true,
        })
      );
    } else {
      dispatch(alertAdd({ text: "Błąd aktualizacji profilu", isError: true }));
    }

    if (canUpdateOrgData) {
      const orgCodeRegistration = orgCodeRequired ? orgCode : "";

      response = await dispatch(
        updateMyOrganization({
          orgName,
          additionalOrgDescription,
          customFooter,
          orgMessage,
          orgCodeRegistration,
          enableUserActivation: userActivation,
          enableSelfRegistration: selfRegistration,
          enableCodeRegistration: orgCodeRequired,
          editorsCanManageForms,
          editorsCanManageUsers,
          billingInfo: {
            name: nameFV,
            street: streetFV,
            zipCode: zipFV,
            city: cityFV,
            post: postFV,
            taxId: nipFV,
          },
          ...(formDataCreatedWebhookUrl ? { formDataCreatedWebhookUrl } : {}),
        })
      );

      if (response.status === 200) {
        dispatch(
          alertAdd({ text: "Zaktualizowano dane organizacji", isSuccess: true })
        );
      } else {
        dispatch(
          alertAdd({
            text: "Błąd aktualizacji danych organizacji",
            isError: true,
          })
        );
      }

      setBusy(false);
    }
  };

  const handleStartDateChange = (date) => {
    setDataChanged(true);
    if (date) {
      setYearOfBirth(new Date(date).getFullYear().toString());
    } else {
      setYearOfBirth("");
    }
  };

  const page = () => (
    <div className={classes.root}>
      <Prompt
        key="block-nav"
        when={dataChanged}
        message="Edytowane dane nie zostały zapisane, czy mimo to chcesz opuścić stronę?"
      />{" "}
      <Box>
        {" "}
        <Box display="flex" flexDirection="row" p={1}>
          <Box p={1}>
            <PageTitle title="Profil" />
          </Box>
          {enableEmailEdition && (
            <Box
              p={1}
              display="flex"
              justifyContent="center"
              alignItems="center"
            >
              <Tooltip
                title={"Twój identyfikator systemowy"}
                className={classes.fontSize}
              >
                <span
                  style={{
                    // fontSize: "0.8rem",
                    lineHeight: "1.4",
                    color: globalTheme === "high-contrast" ? "#fff200" : "#999",
                  }}
                >
                  {my?.id}
                </span>
              </Tooltip>
            </Box>
          )}
        </Box>
        <Box p={1}>
          {" "}
          <Grid container spacing={3}>
            <Grid item xs={12} sm={8} lg={6} spacing={3}>
              <Paper className={classes.paper}>
                <Typography variant="h6">Dane personalne:</Typography>
                <br />

                <Grid item container sm={12} lg={8} xl={6} spacing={1}>
                  <Grid item xs={12}>
                    <TextField
                      InputLabelProps={{
                        className: classes.floatingLabelFocusStyle,
                      }}
                      label="Imię"
                      color="text"
                      variant="outlined"
                      disabled={!enableProfileDataEdition}
                      value={firstName}
                      fullWidth
                      onChange={({ target: { value: firstName } }) => {
                        setDataChanged(true);
                        setFirstName(firstName);
                      }}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <TextField
                      InputLabelProps={{
                        className: classes.floatingLabelFocusStyle,
                      }}
                      label="Nazwisko"
                      variant="outlined"
                      disabled={!enableProfileDataEdition}
                      value={lastName}
                      fullWidth
                      onChange={({ target: { value: lastName } }) => {
                        setDataChanged(true);
                        setLastName(lastName);
                      }}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <MuiPickersUtilsProvider
                      locale={plLocale}
                      utils={DateFnsUtils}
                    >
                      <KeyboardDatePicker
                        InputLabelProps={{
                          className: classes.floatingLabelFocusStyle,
                        }}
                        style={{ color: "red" }}
                        className={classes.textFieldCSS}
                        disabled={!enableProfileDataEdition}
                        id="start-date-picker-dialog"
                        label="Rok urodzenia"
                        format="yyyy"
                        value={yearOfBirth}
                        fullWidth
                        inputVariant="outlined"
                        onChange={handleStartDateChange}
                        KeyboardButtonProps={{
                          "aria-label": "change date",
                        }}
                        cancelLabel={"Anuluj"}
                        okLabel={"Zatwierdź"}
                        views={["year"]}
                        invalidDateMessage={
                          yearOfBirth?.length > 0 && "Nieprawidłowy format"
                        }
                        maxDateMessage="Błędny rok urodzenia"
                        minDateMessage="Błędny rok urodzenia"
                        maxDate={actualDate}
                        keyboardIcon={
                          <EventIcon
                            style={{
                              color:
                                globalTheme === "high-contrast" && "#fff200",
                            }}
                          />
                        }
                      />
                    </MuiPickersUtilsProvider>
                  </Grid>
                  <Grid item xs={12}>
                    <FormControl fullWidth variant="outlined">
                      <InputLabel id="select-outlined-label">Płeć</InputLabel>
                      <Select
                        labelId="select-outlined-label"
                        id="select-outlined"
                        disabled={!enableProfileDataEdition}
                        fullWidth
                        value={selectedGender}
                        onChange={(event) => {
                          setDataChanged(true);
                          setSelectedGender(event.target.value);
                        }}
                        label="Płeć"
                      >
                        {genderTypes.map((genderType, index) => {
                          return (
                            <MenuItem key={index} value={genderType.type}>
                              {genderType.description}
                            </MenuItem>
                          );
                        })}
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item xs={12}>
                    <TextField
                      InputLabelProps={{
                        className: classes.floatingLabelFocusStyle,
                      }}
                      label="Nazwa użytkownika"
                      variant="outlined"
                      disabled
                      fullWidth
                      value={username}
                      onChange={({ target: { value: username } }) => {
                        setDataChanged(true);
                        setUsername(username);
                      }}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <TextField
                      InputLabelProps={{
                        className: classes.floatingLabelFocusStyle,
                      }}
                      label="Email"
                      variant="outlined"
                      disabled={
                        !enableProfileDataEdition || !enableEmailEdition
                      }
                      value={email}
                      fullWidth
                      onChange={({ target: { value: email } }) => {
                        setDataChanged(true);
                        setEmail(email);
                      }}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <InputLabel style={{ color: "black" }}>
                      Aktualne zdjęcie:{" "}
                      {avatarPath ? (
                        <img
                          style={{ marginLeft: "130px" }}
                          className={s.avatarImg}
                          src={`/org-media/files${avatarPath}`}
                          alt=""
                        />
                      ) : (
                        <span style={{ fontWeight: "bold" }}>Brak</span>
                      )}
                    </InputLabel>
                  </Grid>
                  <Grid item xs={12}>
                    {newAvatarPath && (
                      <Box mt={1}>
                        <Grid
                          container
                          justify="flex-start"
                          alignItems="flex-start"
                        >
                          <InputLabel style={{ color: "black" }}>
                            Nowe zdjęcie:{" "}
                            <img
                              style={{ marginLeft: "151px" }}
                              className={s.avatarImg}
                              src={newAvatarPath}
                              alt=""
                            />
                          </InputLabel>
                        </Grid>
                      </Box>
                    )}
                    <Button
                      className="button is-primary"
                      variant="contained"
                      component="label"
                      className={classes.fontSize}
                      style={{
                        backgroundColor:
                          globalTheme === "high-contrast"
                            ? "#000"
                            : "lightgrey",
                        color:
                          globalTheme === "high-contrast" ? "#fff200" : "black",
                        border:
                          globalTheme === "high-contrast" &&
                          "1px solid #fff200",
                      }}
                      disabled={!enableProfileDataEdition}
                    >
                      Wgraj zdjęcie
                      <input
                        type="file"
                        hidden
                        disabled={!enableProfileDataEdition}
                        onChange={({ target: { files } }) => {
                          setDataChanged(true);
                          handleUploadedFiles(files);
                        }}
                      />
                    </Button>{" "}
                  </Grid>
                  <Grid item xs={12}>
                    {" "}
                    <a
                      href="#"
                      className={`${
                        globalTheme === "high-contrast" &&
                        classes.aalertHighContrast
                      } ${classes.fontSize}`}
                      onClick={async () => {
                        const response = await dispatch(
                          recoverPassword({
                            ...(email && { email }),
                            ...(phone &&
                              my.user.authorities.localeCompare("ROLE_USER") ===
                                0 && { phone }),
                            ...(my?.user.authorities && {
                              role:
                                my.user.authorities.localeCompare(
                                  "ROLE_USER"
                                ) === 0
                                  ? "patient"
                                  : "employee",
                            }),
                          })
                        );
                        if (response.status === 200) {
                          dispatch(
                            alertAdd({
                              text: "Link do zmiany hasła został wysłany",
                            })
                          );
                        } else {
                          dispatch(
                            alertAdd({
                              text: "Link do zmiany hasła nie został wysłany",
                              isError: true,
                            })
                          );
                        }
                      }}
                    >
                      Zmiana hasła przez email
                    </a>
                  </Grid>
                  <Grid item xs={12}>
                    <NavLink
                      to="/password-change"
                      className={`${
                        globalTheme === "high-contrast" &&
                        classes.aalertHighContrast
                      } ${classes.fontSize}`}
                    >
                      Zmiana hasła (formularz)
                    </NavLink>
                  </Grid>
                </Grid>
              </Paper>
            </Grid>
            <Grid item xs={12} sm={8} lg={6} spacing={3}>
              <Paper className={classes.paper}>
                <Typography variant="h6">Dane adresowe:</Typography>
                <br />

                <ShippingAddressForm
                  provideShippingData={true}
                  name={name || `${firstName} ${lastName}`}
                  setName={setName}
                  street={street}
                  setStreet={setStreet}
                  city={city}
                  setCity={setCity}
                  zip={zip}
                  setZip={setZip}
                  post={post}
                  setPost={setPost}
                  phone={phone}
                  setPhone={setPhone}
                  dialCode={dialCode}
                  setDialCode={setDialCode}
                  enableProfileDataEdition={enableProfileDataEdition}
                  setDataChanged={setDataChanged}
                />
              </Paper>
            </Grid>
            <Grid item xs={12} sm={8} lg={6} spacing={3}>
              <Paper className={classes.paper}>
                <Box
                  display="flex"
                  justifyContent="space-between"
                  alignItems="center"
                >
                  <Typography variant="h6">Kontakt awaryjny:</Typography>
                  <Button
                    size="small"
                    variant="outlined"
                    disabled={
                      !enableProfileDataEdition ||
                      (!emergencyFirstName &&
                        !emergencySurname &&
                        !emergencyPhone &&
                        !emergencyEmail &&
                        !emergencyAddress)
                    }
                    onClick={() => {
                      setEmergencyFirstName("");
                      setEmergencySurname("");
                      setEmergencyPhone("");
                      setEmergencyEmail("");
                      setEmergencyAddress("");
                      setDataChanged(true);
                    }}
                  >
                    Wyczyść
                  </Button>
                </Box>
                <br />
                <Grid item container sm={12} lg={8} xl={6} spacing={1}>
                  <Grid item xs={12}>
                    <TextField
                      label="Imię"
                      variant="outlined"
                      disabled={!enableProfileDataEdition}
                      value={emergencyFirstName}
                      fullWidth
                      inputProps={{ maxLength: 255 }}
                      onChange={({ target: { value } }) => {
                        setDataChanged(true);
                        setEmergencyFirstName(value);
                      }}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <TextField
                      label="Nazwisko"
                      variant="outlined"
                      disabled={!enableProfileDataEdition}
                      value={emergencySurname}
                      fullWidth
                      inputProps={{ maxLength: 255 }}
                      onChange={({ target: { value } }) => {
                        setDataChanged(true);
                        setEmergencySurname(value);
                      }}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <MuiPhoneNumber
                      name="emergency-contact-phone"
                      label="Telefon"
                      defaultCountry={"pl"}
                      variant="outlined"
                      disabled={!enableProfileDataEdition}
                      value={emergencyPhone}
                      fullWidth
                      inputProps={{ maxLength: 255 }}
                      onChange={(value) => {
                        setDataChanged(true);
                        setEmergencyPhone(value);
                      }}
                      helperText="Podaj telefon lub email (lub oba)"
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <TextField
                      label="Email"
                      variant="outlined"
                      disabled={!enableProfileDataEdition}
                      value={emergencyEmail}
                      fullWidth
                      inputProps={{ maxLength: 255 }}
                      onChange={({ target: { value } }) => {
                        setDataChanged(true);
                        setEmergencyEmail(value);
                      }}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <TextField
                      label="Adres"
                      variant="outlined"
                      disabled={!enableProfileDataEdition}
                      value={emergencyAddress}
                      fullWidth
                      multiline
                      rows={2}
                      inputProps={{ maxLength: 1024 }}
                      onChange={({ target: { value } }) => {
                        setDataChanged(true);
                        setEmergencyAddress(value);
                      }}
                    />
                  </Grid>
                </Grid>
              </Paper>
            </Grid>
            <Can
              permission="orgDetails:change"
              ok={() => (
                <Grid item xs={12} sm={8} lg={6} spacing={3}>
                  <Paper className={classes.paper}>
                    <Typography variant="h6">Dane organizacji:</Typography>
                    <br />
                    <Grid
                      item
                      container
                      lg={12}
                      xl={8}
                      spacing={1}
                      direction="column"
                    >
                      <Grid item xs={12}>
                        <TextField
                          label="Nazwa organizacji"
                          variant="outlined"
                          fullWidth
                          value={orgName || ""}
                          onChange={({ target: { value: orgName } }) => {
                            setDataChanged(true);
                            setOrgName(orgName);
                          }}
                        />
                      </Grid>
                      <Grid item xs={12}>
                        <TextField
                          label="Opis organizacji"
                          variant="outlined"
                          fullWidth
                          multiline
                          rows={4}
                          value={additionalOrgDescription}
                          onChange={({ target: { value } }) => {
                            setDataChanged(true);
                            setAdditionalOrgDescription(value);
                          }}
                        />
                      </Grid>
                      <Grid item xs={12}>
                        <TextField
                          label="Stopka używana w wiadomościach email/sms"
                          variant="outlined"
                          fullWidth
                          value={customFooter}
                          onChange={({ target: { value: customFooter } }) => {
                            setDataChanged(true);
                            setCustomFooter(customFooter);
                          }}
                        />
                      </Grid>
                      <Grid item xs={12}>
                        <FormControlLabel
                          style={{
                            color: globalTheme === "high-contrast" && "#fff200",
                          }}
                          control={
                            <ContrastCheckbox
                              checked={selfRegistration || false}
                              name="checkedB"
                              color="primary"
                              onChange={(e) => {
                                setDataChanged(true);
                                setSelfRegistration(!selfRegistration);
                                selfRegistration && setUserActivation(false);
                                selfRegistration && setOrgCodeRequired(false);
                              }}
                            />
                          }
                          label="Umożliwienie samodzielnej rejestracji do
                            organizacji"
                        />
                      </Grid>
                      {selfRegistration && (
                        <Grid item xs={12}>
                          <FormControlLabel
                            control={
                              <ContrastCheckbox
                                checked={userActivation || false}
                                name="checkedB"
                                color="primary"
                                onChange={() => {
                                  setDataChanged(true);
                                  setUserActivation(!userActivation);
                                }}
                                disabled={!selfRegistration}
                              />
                            }
                            label="Aktywacja nowych użytkowników przy samodzielnej
                            rejestracji"
                          />
                        </Grid>
                      )}
                      {selfRegistration && (
                        <Grid item xs={12}>
                          <FormControlLabel
                            control={
                              <ContrastCheckbox
                                checked={orgCodeRequired || false}
                                name="checkedB"
                                color="primary"
                                onChange={() => {
                                  setDataChanged(true);
                                  setOrgCodeRequired(!orgCodeRequired);
                                  setOrgCode("");
                                }}
                                disabled={!selfRegistration}
                              />
                            }
                            label="Rejestracja użytkowników przez kod"
                          />
                        </Grid>
                      )}
                      {orgCodeRequired && selfRegistration && (
                        <Grid item xs={12}>
                          <TextField
                            label="Kod dołączenia do organizacji"
                            variant="outlined"
                            fullWidth
                            value={orgCode}
                            onChange={({ target: { value } }) => {
                              setDataChanged(true);
                              setOrgCode(value);
                            }}
                            disabled={!selfRegistration}
                          />
                        </Grid>
                      )}
                      {displayHint && selfRegistration && (
                        <span className={s.formHint}>
                          Kod musi zawierać co najmniej 8 znaków.
                        </span>
                      )}
                      <Grid item xs={12}>
                        <FormControlLabel
                          control={
                            <ContrastCheckbox
                              checked={editorsCanManageForms || false}
                              name="checkedB1"
                              color="primary"
                              onChange={() => {
                                setDataChanged(true);
                                setEditorsCanManageForms(
                                  !editorsCanManageForms
                                );
                              }}
                            />
                          }
                          label={
                            process.env.REACT_APP_USE_DOCTOR === "true"
                              ? "Dodatkowe prawa dla lekarza w zakresie zarządzania formularzami"
                              : "Dodatkowe prawa dla redaktora w zakresie zarządzania formularzami"
                          }
                        />
                      </Grid>
                      <Grid item xs={12}>
                        <FormControlLabel
                          control={
                            <ContrastCheckbox
                              checked={editorsCanManageUsers || false}
                              name="checkedB1"
                              color="primary"
                              onChange={() => {
                                setDataChanged(true);
                                setEditorsCanManageUsers(
                                  !editorsCanManageUsers
                                );
                              }}
                            />
                          }
                          label={`Dodatkowe prawa dla ${
                            process.env.REACT_APP_USE_DOCTOR === "true"
                              ? "lekarza"
                              : "redaktora"
                          } w zakresie zarządzania ${
                            process.env.REACT_APP_USE_PATIENT === "true"
                              ? "pacjentami"
                              : "użytkownikami"
                          }`}
                        />
                      </Grid>

                      {
                        <Can
                          permission="apikeys"
                          ok={() => (
                            <Grid item xs={12}>
                              <NavLink
                                className={
                                  globalTheme === "high-contrast" &&
                                  classes.aalertHighContrast
                                }
                                to="/profile/api-keys"
                              >
                                Klucze API
                              </NavLink>
                            </Grid>
                          )}
                        />
                      }
                      {
                        <Can
                          permission="webhooks"
                          ok={() => (
                            <Grid item xs={12}>
                              <TextField
                                label="Adres webhook do informowania o zdarzeniach w systemie"
                                variant="outlined"
                                fullWidth
                                value={formDataCreatedWebhookUrl}
                                onChange={({ target: { value } }) => {
                                  setDataChanged(true);
                                  setFormDataCreatedWebhookUrl(value);
                                }}
                              />
                            </Grid>
                          )}
                        />
                      }
                    </Grid>
                  </Paper>
                </Grid>
              )}
            />
            <Grid item xs={12} sm={8} lg={6} spacing={3}>
              <Paper className={classes.paper}>
                <Typography variant="h6">Regulaminy:</Typography>
                <br />
                <NavLink
                  className={
                    globalTheme === "high-contrast" &&
                    classes.aalertHighContrast
                  }
                  to="/terms-management"
                >
                  Przejdz do regulaminow
                </NavLink>
              </Paper>
            </Grid>

            <Grid item xs={12}>
              <Button
                className={classnames(
                  "button is-primary",
                  {
                    "is-loading": busy,
                  },
                  classes.fontSize
                )}
                type="submit"
                variant={"contained"}
                style={{
                  backgroundColor:
                    globalTheme === "high-contrast" ? "yellow" : "blue",
                  color: globalTheme === "high-contrast" ? "black" : "white",
                  border: globalTheme === "high-contrast" && "1px solid yellow",
                }}
                disabled={
                  !enableProfileDataEdition ||
                  !dataProvidedValid ||
                  !yearProvidedValid ||
                  (!phone && !email)
                }
                onClick={() => {
                  if (orgCodeRequired === false || orgCode.length >= 8) {
                    save();
                    setDisplayHint(false);
                  } else {
                    setDisplayHint(true);
                  }
                }}
              >
                Zapisz
              </Button>
              <Button
                // className=
                className={classes.fontSize}
                type="cancel"
                variant={"contained"}
                style={{
                  marginLeft: "10px",
                  backgroundColor:
                    globalTheme === "high-contrast" ? "black" : "lightgrey",
                  color: globalTheme === "high-contrast" ? "yellow" : "black",
                  border: globalTheme === "high-contrast" && "1px solid yellow",
                }}
                onClick={() => history.push("/")}
              >
                Anuluj
              </Button>
            </Grid>
          </Grid>
        </Box>
      </Box>
    </div>
  );

  const redirect = () => <Redirect to={getLoginRedirectPath()} />;

  return <Can permission="profilePage:view" ok={page} not={redirect} />;
};

export default ProfilePage;
